import React, { useState, useEffect, useRef } from 'react';
import { Input, Modal, Form, Upload, message, Select, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import NewMessage from '../../component/newMessage/newMessage';
import { useParams } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';

import './partnerChangePassword.css';

import saveImg from '../../public/img/newMain/Save.png';
import { partnerCheckLogin } from '../newMain/partnerMain';
import { useHistory, Route, Switch, useLocation } from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;

const PartnerChangePassword = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [partnerContactModel, setPartnerContactModel] = useState({});
    const history = useHistory();

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchChangePasswordById(Config.userInfo?.userId);
    }, []);

    const searchChangePasswordById = (userId) => {
        Base.callBackApi("partnerDetail/searchChangePasswordById", {'userId': userId}).then(async (data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setPartnerContactModel(model)
            } else {
                message.error(data.msg)
            }
        })
    }

    const update = () => {
        if(!Base.stopClick()) {
            return
        }
        form.submit();
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        values.userId = partnerContactModel.userId;
        values.lastUpdatedDate = partnerContactModel.lastUpdatedDate;
        values.pwd = values.confirmPassword;
        setIsLoad(true);
        Base.callBackApi("partnerDetail/changePwd", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully Changed Password.");
                Config.userInfo.changePwdDate = Date.now();
                Config.userInfo.operationFlag = false;
            } else {
                message.error(data.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        history.push('/partner/partnerHome')
    }

    const validatePassword = async (_, value) => {
        if (!value) {
            throw new Error("New Password is required.");
        }
        // 密码长度至少为8位
        if (value.length < 8) {
            throw new Error("The New Password must have at least 8 digits.");
        }
        // 密码需要包含大写字母、小写字母、数字和特殊字符
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()`!@#$%^&*_\-+=|{}[\]:;'<>,.?])[A-Za-z\d()`!@#$%^&*_\-+=|{}[\]:;'<>,.?]+$/;
        if (!passwordRegex.test(value)) {
            throw new Error("The New Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.");
        }
        // 密码不能包含个人信息
        // const personalInfo = [partnerContactModel?.contactName, partnerContactModel?.contactMobilePhone, partnerContactModel?.contactOfficePhone, partnerContactModel?.partnerContactAcctId];
        const personalInfo = [partnerContactModel?.contactName];
        if (personalInfo.some(info => value.includes(info))) {
            throw new Error("The New Password cannot contain user name.");
        }
        return Promise.resolve();
    };

    return (
        <div id="container" className='websiteTemplate PartnerChangePassword'>
            <NewMessage ref={messageRef} done={done} />
            <Spin size="large" spinning={isLoad} >
                <Form form={form} onFinish={onFinish}>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle">Change Password</div>
                    </div>
                    <div className="websiteSysContentBox">
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">New Password</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="newPassword"
                                        rules={[
                                            { validator: validatePassword }
                                        ]}
                                    >
                                        <Input type="password" placeholder="New Password" maxLength={20} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">New Password (Confirm)</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="confirmPassword"
                                        dependencies={['newPassword']}
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (value && getFieldValue('newPassword') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The New Password is not consistent with the New Password (Confirm).'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input type="password" placeholder="New Password (Confirm)" maxLength={20} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {Config.userInfo.operationFlag && <div className='newInfoStyle'>Please enter a new password as your password has been changed by the administrator or if this is your first time logging in.</div>}
                    <div className="websiteSysButtonBox">
                        <div className='websiteSysButton' onClick={() => update()}><img src={saveImg} />Save</div>
                    </div>
                </Form>
            </Spin>
        </div>
    )

}

export default PartnerChangePassword;